import { render } from "./ResidentsInactiveTable.vue?vue&type=template&id=0824b90a&ts=true"
import script from "./ResidentsInactiveTable.vue?vue&type=script&lang=ts"
export * from "./ResidentsInactiveTable.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__